/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Group_BackstageInputs */

const en_enum_setting_group_backstage = /** @type {(inputs: Enum_Setting_Group_BackstageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Backstage`)
};

const de_enum_setting_group_backstage = /** @type {(inputs: Enum_Setting_Group_BackstageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe Backstage`)
};

/**
* | output |
* | --- |
* | "Group Backstage" |
*
* @param {Enum_Setting_Group_BackstageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_group_backstage = /** @type {((inputs?: Enum_Setting_Group_BackstageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Group_BackstageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_group_backstage(inputs)
	return de_enum_setting_group_backstage(inputs)
});